export default __webpack_public_path__ + "static/media/lupa_mapa.c1ae2904.png";